import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClBaseComponent } from '../cl-base/cl-base.component';
import { Resource } from 'src/app/components/catalogs/beamline-catalog/resource/resources';
import { ResourceType } from 'src/app/common/enumerations/enumerations';

@Component({
  selector: 'cl-brc-forms',
  templateUrl: './cl-brc-forms.component.html',
  styleUrls: ['./cl-brc-forms.component.scss']
})
export class ClBrcFormsComponent extends ClBaseComponent implements OnInit, OnDestroy {

  @Input() resourceID?: number;

  private resourcesSubs?: Subscription;

  override get labelHtml(): string {
    return 'Review any related open <b class="blue">BRC Forms</b> to verify that key-enable may proceed.';
  }

  ngOnInit(): void {
    if (!this.editor && !this.builder) {
      this.loadResources();
    }
  }

  override ngOnDestroy(): void {
    this.resourcesSubs?.unsubscribe();
    super.ngOnDestroy();
  }

  checkboxChanged(e: any) {
    this.checked = e.checked;
    this.user = this.checked ? this.getCurrentUser(true) : null;
    this.answered.emit(this.checked);
  }

  loadResources() {
    this.resourcesSubs?.unsubscribe();
    this.resourcesSubs = this.store.select(state => state.Resources.data).subscribe((data: Resource[]) => {
      if (!data.length || !this.resourceID) return;

      const resource = data.find(r => r.id === this.resourceID);
      let beamline: Resource | undefined;

      if (resource?.resourceTypeID === ResourceType.Shutter) {
        const beamlineId = resource.childResources?.find(cr => cr.childResourceType === ResourceType.Beamline)?.childResourceID;
        beamline = data.find(r => r.id === beamlineId);
      } else if (resource?.resourceTypeID === ResourceType.Beamline) {
        beamline = resource;
      }

      if (beamline === undefined) return;

      const keChecked = !beamline.keRestricted;
      if (this.checked === keChecked) return;

      this.checked = keChecked;
      this.disabled = !!beamline.keRestricted;
      this.answered.emit(this.checked);
    });
  }
}
